<!-- eslint-disable no-return-assign -->
<script>
import { constants } from '@src/constants/safehaven'

export default {
  props: {
    group: {
      type: Number,
      default: 0,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    noGutters: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      selectedTab: null,
      checkbox: true,
      selectedCard: [],
      menuItems: constants.healthRecordAddModel,
    }
  },
  computed: {
    menuItemsFiltered() {
      const show = Object.values(this.menuItems).filter((el) => {
        if (el.model_name === 'symptomcheaker') {
          return true
        }
        return el.show_menu
      })

      if (this.selectedTab) {
        return show.filter((el) => {
          return el.group === this.selectedTab
        })
      } else {
        return show
      }
    },
  },
  watch: {
    group(newValue, oldValue) {
      this.selectedTab = newValue
    },
  },
  mounted() {
    this.selectedTab = this.group
  },
  methods: {
    selectEvent() {
      this.$emit('select-changed', this.selectedCard)
    },
    selectAllEvent(ev) {
      if (ev) this.selectAll()
      else this.unselectAll()
    },
    selectAll() {
      this.selectedCard = this.menuItemsFiltered
      this.selectEvent()
    },
    unselectAll() {
      this.selectedCard = []
      this.selectEvent()
    },
  },
}
</script>

<template>
  <div>
    <v-item-group
      v-model="selectedCard"
      :multiple="multiple"
      class="mb-2"
      @change="selectEvent"
    >
      <v-container>
        <v-row v-if="multiple" no-gutters>
          <v-checkbox @change="selectAllEvent">
            <template v-slot:label
              ><span :class="$style.selectAllText">Select All</span></template
            >
          </v-checkbox>
        </v-row>
        <v-row no-gutters>
          <v-col
            v-for="item in menuItemsFiltered"
            :key="item.value"
            cols="12"
            sm="4"
            class="pa-0"
          >
            <v-item v-slot="{ active, toggle }" :value="item">
              <v-sheet flat @click="toggle">
                <v-checkbox :value="active" class="pt-0 mt-0">
                  <template v-slot:label
                    ><span :class="$style.listText">{{
                      $t(item.menu_title)
                    }}</span></template
                  >
                </v-checkbox>
              </v-sheet>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.menuTab :hover {
  color: white;
  background: $color-theme-light-primary;
  border-radius: 24px;
}

.tab {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.25px;
}

.cardsContainer {
  padding-right: 120px !important;
  padding-left: 120px !important;
}

@media screen and (max-width: 960px) {
  .cardsContainer {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.hrCard {
  border-radius: 16px !important;
}

.activeCard {
  border: 1px solid $color-theme-light-secondary !important;
}

.cardText {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.75px;
}

.listText {
  font-size: 14px;
  color: #454648 !important;
  text-transform: capitalize !important;
}

.selectAllText {
  font-size: 14px;
  color: #454648 !important;
}
</style>
